import { Component, computed, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';

import { ErrorPageLayoutComponent } from '@core/components/error-page-layout/error-page-layout.component';
import {
  LoginErrorService,
  TERMS_DECLINED_DESCRIPTION
} from '@core/services/auth/login-error.service';
import { ICONS } from '@core/services/icons/icons.service';

/**
 * Where angular-auth-oidc-client lands any login callback it could not complete. Only a
 * declined terms page gets the terms wording; every other cause gets a generic message.
 */
@Component({
  selector: 'app-access-denied',
  imports: [TranslatePipe, ErrorPageLayoutComponent],
  templateUrl: './access-denied.component.html',
  styles: ``
})
export class AccessDeniedComponent {
  private readonly oidc = inject(OidcSecurityService);
  private readonly loginError = inject(LoginErrorService).loginError;

  protected readonly ICONS = ICONS;

  protected readonly termsDeclined = computed(() => {
    const error = this.loginError();
    return (
      error?.error === 'access_denied' && error.description === TERMS_DECLINED_DESCRIPTION
    );
  });

  protected signInAgain(): void {
    this.oidc.authorize();
  }
}
